import styles from './index.less';
import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import RoleEditorModalStore from './store';

const RoleEditorModal = ({ onClose, store }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  /* 门派/性别按钮两态改为代码绘制：设计仅交付武当/男性两张选中态样图（其余按钮两态图缺失，
     且确认不再补设计），按样图规格以「边框 + 文字颜色」区分两态，替代原 已选中态/未选中态 双图片图层 */
  const getOptionButtonClassName = isSelected => cx(styles.optionButton, isSelected && styles.optionButtonSelected);

  return (
    <ModalContainer modalState={store.isOpen}>
      {/* 忠实转换自 psd-to-html/mo-poster 的 弹窗-门派选择（group-49）图层子树；
          画布级定位交由 ModalContainer 承载，内部子节点保留 PSD 相对坐标。
          五门派 / 两性别按钮按草稿键切换 代码态选中类（optionButton/optionButtonSelected），
          草稿等运行期变化数据一律读取弹窗 Store（observable），不依赖一次性 props 快照。 */}
      <div className={styles.root} data-name="弹窗-门派选择">
        <div className={styles.layer84} data-name="弹窗-门派背景" />
        <div className={styles.group50} data-name="弹窗主体">
          <div className={styles.group51} data-name="选择门派及性别区">
            <div className={styles.group52} data-name="门派选择区">
              <div className={styles.group53} data-name="选择按钮区">
                <button
                  className={cx(styles.group54, styles.hitArea, getOptionButtonClassName(store.draftSect === 'tianwang'))}
                  data-name="天王"
                  type="button"
                  aria-label="选择天王"
                  aria-pressed={store.draftSect === 'tianwang'}
                  onClick={() => store.selectDraftSect('tianwang')}
                >
                  <span className={styles.optionButtonText}>天王</span>
                </button>

                <button
                  className={cx(styles.group55, styles.hitArea, getOptionButtonClassName(store.draftSect === 'qianji'))}
                  data-name="千机"
                  type="button"
                  aria-label="选择千机"
                  aria-pressed={store.draftSect === 'qianji'}
                  onClick={() => store.selectDraftSect('qianji')}
                >
                  <span className={styles.optionButtonText}>千机</span>
                </button>

                <button
                  className={cx(styles.group56, styles.hitArea, getOptionButtonClassName(store.draftSect === 'jinzhong'))}
                  data-name="烬宗"
                  type="button"
                  aria-label="选择烬宗"
                  aria-pressed={store.draftSect === 'jinzhong'}
                  onClick={() => store.selectDraftSect('jinzhong')}
                >
                  <span className={styles.optionButtonText}>烬宗</span>
                </button>

                <button
                  className={cx(styles.group57, styles.hitArea, getOptionButtonClassName(store.draftSect === 'yishui'))}
                  data-name="易水"
                  type="button"
                  aria-label="选择易水"
                  aria-pressed={store.draftSect === 'yishui'}
                  onClick={() => store.selectDraftSect('yishui')}
                >
                  <span className={styles.optionButtonText}>易水</span>
                </button>

                <button
                  className={cx(styles.group58, styles.hitArea, getOptionButtonClassName(store.draftSect === 'wudang'))}
                  data-name="武当"
                  type="button"
                  aria-label="选择武当"
                  aria-pressed={store.draftSect === 'wudang'}
                  onClick={() => store.selectDraftSect('wudang')}
                >
                  <span className={styles.optionButtonText}>武当</span>
                </button>
              </div>

              <div className={styles.layer95} data-name="选择门派：">
                选择门派：
              </div>
            </div>

            <div className={styles.group59} data-name="性别选择区">
              <div className={styles.group60} data-name="选择按钮区">
                <button
                  className={cx(styles.group61, styles.hitArea, getOptionButtonClassName(store.draftGender === 'female'))}
                  data-name="女性"
                  type="button"
                  aria-label="选择女性"
                  aria-pressed={store.draftGender === 'female'}
                  onClick={() => store.selectDraftGender('female')}
                >
                  <span className={styles.optionButtonText}>女性</span>
                </button>

                <button
                  className={cx(styles.group62, styles.hitArea, getOptionButtonClassName(store.draftGender === 'male'))}
                  data-name="男性"
                  type="button"
                  aria-label="选择男性"
                  aria-pressed={store.draftGender === 'male'}
                  onClick={() => store.selectDraftGender('male')}
                >
                  <span className={styles.optionButtonText}>男性</span>
                </button>
              </div>

              <div className={styles.layer100} data-name="选择性别：">
                选择性别：
              </div>
            </div>
          </div>

          <button
            className={cx(styles.layer101, styles.hitArea)}
            data-name="确认修改"
            type="button"
            aria-label="确认修改门派与性别"
            onClick={store.confirmDraft}
          />
          <div className={styles.layer102} data-name="分别选择门派和性别">
            分别选择门派和性别
          </div>
        </div>

        <button className={cx(styles.layer103, styles.hitArea)} data-name="关闭按钮" type="button" aria-label="关闭门派选择弹窗" onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(RoleEditorModal, RoleEditorModalStore);
